import {
  GoogleOutlined,
  KeyOutlined,
  LockOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Input, message, Row, Space } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { getSupaClient } from "../lib/supabase";
import animationData from "../lottie/dots-circle.json";
import { logout } from "../utils/general";

const SignIn = ({ checkSessionWorkspace }) => {
  const supabase = getSupaClient();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  setTimeout(checkSessionWorkspace, 1000);

  const handleLogin = async () => {
    logout();
    const { user, error } = await supabase.auth.signIn({ email, password });

    // if (user) console.log("auth.js user", user);
    if (error) console.log("auth.js error", error);

    if (error) {
      console.log("in error section", error);
      message.error(`Error: ${error.message}`);
      return null;
    }
    if (!user && !error) {
      console.log("in email section");
      message.success(`"An email has been sent to you for verification!"`);
      return null;
    }
    // console.log("in redirect section");
    // console.log("users");
    window.analytics.track("Signed in");
    window.posthog.capture("Signed in");
    window.posthog.people.set({ email });
    return navigate("/home");
  };

  const handleOAuthLogin = async () => {
    logout();
    const { user, error } = await supabase.auth.signIn({
      provider: "google",
    });
    if (user) {
      console.log("google singed in", user);
      window.analytics.track("Signed in");
      window.posthog.capture("Signed in");
      window.posthog.people.set({ email: user.email });
      return navigate("/home");
    }
    if (error) {
      console.log("Error: ", error.message);
      message.error(`Error: ${error.message}`);
      return null;
    }
    return true;
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Row
      type="flex"
      justify="center"
      align="middle"
      style={{ minHeight: "100vh", padding: "0 200px" }}
    >
      <Card style={{ textAlign: "center", paddingTop: 20 }}>
        <h3>Let&#39;s start saving you more time 😃</h3>
        <Row align="middle" justify="center">
          <Col lg={15} md={11} sm={24} style={{ padding: "0 20" }}>
            {/* <img alt="sing in" src="/analyse.png" width="400" /> */}
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "90%", padding: 30 }}>
                <img className="fit-width" alt="sing in" src="/analyse.png" />
              </div>
            </div>
          </Col>
          <Col lg={9} md={13} sm={24} style={{ margin: "auto" }}>
            <Space style={{ width: "100%" }} size={12} direction="vertical">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <img
                  src="/logo.png"
                  style={{ marginBottom: 20 }}
                  width="150"
                  alt="logo"
                />
              </div>
              <Button style={{ marginTop: 20 }} type="link" href="/signup">
                Trying to sign up?
              </Button>

              <Input
                placeholder="Email"
                size="large"
                prefix={<MailOutlined />}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: "100%", borderRadius: 5, marginTop: 20 }}
              />

              <Input.Password
                prefix={<KeyOutlined />}
                size="large"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ width: "100%", borderRadius: 5 }}
              />

              <Button
                style={{ borderRadius: 5 }}
                size="large"
                icon={<LockOutlined />}
                block
                type="primary"
                onClick={() => handleLogin()}
              >
                Sign In
              </Button>

              <p>or</p>
              <Button
                style={{ borderRadius: 5, marginTop: -20 }}
                size="large"
                icon={<GoogleOutlined />}
                block
                onClick={() => handleOAuthLogin()}
              >
                Sign In with Google
              </Button>
            </Space>
          </Col>
          <br />
        </Row>
      </Card>
    </Row>
  );
};

export default SignIn;
